import type { FC } from "react";

import { Field } from "@/ui/components/form/Field";
import { Label } from "@/ui/components/form/Label";
import {
  SELECT_DEFAULTS,
  type TSelectProps,
} from "@/ui/components/form/Select/Select.config";
import { SelectContent } from "@/ui/components/form/Select/SelectContent";
import { SelectItem } from "@/ui/components/form/Select/SelectItem";
import { SelectRoot } from "@/ui/components/form/Select/SelectRoot";
import { SelectTrigger } from "@/ui/components/form/Select/SelectTrigger";
import { SelectValue } from "@/ui/components/form/Select/SelectValue";
import { Grid } from "@/ui/components/layout/Grid";
import { Column } from "@/ui/components/layout/Column";
import { cn } from "@/ui/lib/utils";

export const Select: FC<TSelectProps> = (
  {
    className,
    contentClassName,
    disabled,
    error,
    id,
    label,
    options,
    placeholder = SELECT_DEFAULTS.placeholder,
    triggerClassName,
    ...props
  },
) => (
  <Field
    data-component="Select"
    className={cn(
      "cursor-pointer grid gap-x-2",
      disabled && "cursor-not-allowed",
      className,
    )}
  >
    <Grid gap="3">
      <Column>
        <Label>
          { label }
        </Label>
      </Column>
      <Column>
        <SelectRoot {...props} disabled={disabled}>
          <SelectTrigger
            id={id}
            error={error}
            disabled={disabled}
            className={triggerClassName}
          >
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent className={contentClassName}>
            { options.map((option) => (
              <SelectItem
                key={option.value}
                value={option.value}
                disabled={option.disabled}
                icon={option.icon}
              >
                { option.label }
              </SelectItem>
            )) }
          </SelectContent>
        </SelectRoot>
      </Column>
    </Grid>
  </Field>
);

Select.displayName = "Select";
